import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { $http } from '@/axios';
import { getToastMsg } from '@/store/organization/util';
import { sleep } from '@/utils/helper';
import store from '@/store';
import router from '@/plugins/router';

// 查询组织列表
export const queryEnterprises: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setEnterprises', { ...state.list, loading: true });
    const res: IPageData = await $http.post('/baseinfo/enterprise', payload);
    commit('setEnterprises', { data: res.list, total: res.total, pageNum: res.pageNum, pageSize: res.pageSize });
  } catch (e) {
    commit('setEnterprises', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 查看组织详情
export const queryEnterpriseDetail: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setEnterpriseDetail', { ...state.detail, loading: true });
    const res = await $http.get(`/baseinfo/enterprise/${payload}`);
    commit('setEnterpriseDetail', { data: res });
    return res;
  } catch (e) {
    commit('setEnterpriseDetail', { data: null });
  }
};

// 添加组织
export const addEnterprise: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    const res: any = await $http.post('/baseinfo/enterprise/add', payload);
    const toast = getToastMsg(res.account, res.organization.code, false);
    commit('setLoading', false);
    store.commit('common/setToast', { visible: true, text: toast.msg, timeout: toast.timeout });
    await sleep(2);
    await router.push({ name: 'org-enterprise' });
  } finally {
    commit('setLoading', false);
  }
};

// 编辑组织
export const editEnterprise: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    const res: any = await $http.post('/baseinfo/enterprise/modify', payload);
    const toast = getToastMsg(res.account, res.organization.code, true);
    store.commit('common/setToast', { visible: true, text: toast.msg, timeout: toast.timeout });
  } finally {
    commit('setLoading', false);
  }
};

// 检查组织下是否有活跃用户和子组织
export const checkOrgs: IActionFn<IModuleState> = ({ commit, state }, payload) => {
  // const fetchUsers = $http.post('/baseinfo/users', { pageNum: 1, pageSize: 1, status: [1], orgId: payload });
  // const fetchSubOrgs = $http.post('baseinfo/enterprise/suborgs/search', { pageNum: 1, pageSize: 1, orgId: payload });
  const fetchUsers = $http.post(
    '/v1/baseinfo/user/pagelist',
    { pageNum: 1, pageSize: 1, status: [1], orgId: payload },
  );
  const fetchSubOrgs = $http.post(
    '/v1/system/suborg/search',
    { pageNum: 1, pageSize: 1, orgId: payload },
  );

  return new Promise((resolve, reject) => {
    Promise.all([fetchUsers, fetchSubOrgs]).then((results) => {
      const [users, subOrgs] = (results || []) as unknown as IPageData[];
      const userTotal = users?.total || 0;
      const subTotal = subOrgs?.total || 0;
      resolve({ user: userTotal, subOrg: subTotal });
    }).catch(() => {
      reject();
    });
  });
};

// 删除组织
export const deleteEnterprise: IActionFn<IModuleState> = async ({ dispatch, commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/baseinfo/enterprise/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 激活组织
export const activeEnterprise: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/baseinfo/enterprise/activation', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 锁定组织
export const lockEnterprise: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/baseinfo/enterprise/lock', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 查询子组织列表
export const querySubOrgs: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setSubOrgs', { ...state.subList, loading: true });
    // const res: IPageData = await $http.post('baseinfo/enterprise/suborgs/search', payload);
    const res: IPageData = await $http.post('/v1/system/suborg/search', payload);
    commit('setSubOrgs', { data: res.list, total: res.total, pageNum: res.pageNum, pageSize: res.pageSize });
  } catch (e) {
    commit('setSubOrgs', { data: [], total: 0, pageNum: 0, pageSize: 0 });
  }
};

// 添加子组织
export const addSubEnterprise: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    const res: any = await $http.post('/baseinfo/enterprise/add', payload);
    const toast = getToastMsg(res.account, res.organization.code, false);
    store.commit('common/setToast', { visible: true, text: toast.msg, timeout: toast.timeout });
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 是否允许创建子组织
export const restrictEnterprise: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('baseinfo/enterprise/set/restricted', payload);
    await $http.post('/v1/check/org/supportsuborg', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 查询组织中已授权品牌列表
export const queryAuths: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setAuths', { ...state.auths, loading: true });
    // const res: IPageData = await $http.post('/baseinfo/organizations/brand/detail', payload);
    const res: IPageData = await $http.post('/v1/system/org/authbrands', payload);
    commit('setAuths', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setAuths', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询组织中未授权品牌列表
export const queryUnAuths: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setUnAuths', { ...state.unAuths, loading: true });
    const res: IPageData = await $http.post('/baseinfo/organizations/brand/list', payload);
    commit('setUnAuths', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setUnAuths', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询子组织中已授权品牌列表
export const querySubAuths: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setAuths', { ...state.auths, loading: true });
    const res: IPageData = await $http.post('/baseinfo/suborg/brand/detail', payload);
    commit('setAuths', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setAuths', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询子组织中未授权品牌列表
export const querySubUnAuths: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setUnAuths', { ...state.unAuths, loading: true });
    const res: IPageData = await $http.post('/baseinfo/suborg/brand/list', payload);
    commit('setUnAuths', { data: res.list, pageNum: 1, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setUnAuths', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 添加授权
export const saveAuth: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    // await $http.post('/authorization/ref/brand/create', payload);
    await $http.post('/v1/system/org/authbrand/add', payload);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 解除授权
export const deleteAuth: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/authorization/org/ref/delete', payload);
    await $http.post('/v1/system/org/authbrand/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 修改品牌拥有者
export const changeOwner: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    // await $http.post('/brand/auth/modify', payload);
    await $http.post('/v1/baseinfo/brand/modifyowner', payload);
  } finally {
    commit('setLoading', false);
  }
};

// 查询竞品品牌列表
export const queryCompetitors: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setCompetitors', { ...state.competitors, loading: true });
    // const res: IPageData = await $http.post('data/org/competitive/brand/list', payload);
    const res: IPageData = await $http.post('/v1/system/org/competitivebrands', payload);
    commit('setCompetitors', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setCompetitors', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询非竞品列表
export const queryUnCompetitors: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setUnCompetitors', { ...state.unCompetitors, loading: true });
    const res: IPageData = await $http.post('/data/competitive/brand/search', payload);
    commit('setUnCompetitors', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setUnCompetitors', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 批量新增竞品
export const addCompetitors: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDialog', { ...state.dialog, loading: true });
    // await $http.post('/competitive/brand/batch/add', payload);
    await $http.post('/v1/system/org/competitivebrand/add', payload);
  } finally {
    commit('setDialog', { visible: false });
  }
};

// 批量删除竞品
export const deleteCompetitors: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/competitive/brand/batch/delete', payload);
    await $http.post('/v1/system/org/competitivebrand/delete', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};
